import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getFileToken } from '@webapp/account/src/resources/survey';
import { selectFileLink } from '@webapp/account/src/resources/survey/selectors';

import { useActions } from '@webapp/common/hooks/use-actions';
import { useRouteId } from '@webapp/common/hooks/use-route-id';

import css from './get-file.css';

export const GetFile: FC = () => {
    const { id } = useRouteId();
    const getToken = useActions(getFileToken);
    const fileLink = useSelector(selectFileLink);

    // dispatch thunk'а возвращает промис — заворачиваем в блок,
    // иначе React сохранит его как cleanup и упадёт при размонтировании (FRONT-2AA3)
    useEffect(() => {
        getToken({ fileId: id });
    }, [getToken, id]);

    useEffect(() => {
        if (fileLink) {
            setTimeout(() => {
                window.open('', '_self', '');
                window.close();
            }, 3000);
        }
    }, [fileLink]);

    if (!fileLink) {
        return null;
    }

    return (
        <div className={css.download}>
            <h3>
                <span>Если скачивание не началось, кликните</span>{' '}
                <a download href={fileLink} rel='noreferrer'>
                    здесь
                </a>
            </h3>
        </div>
    );
};
